import localStorageKeys from 'constants/localStorageKeys';
import { oktaAuth } from 'okta/config';
import { RESET_EVENTS } from 'redux/home/homeTypes';
import { EVENT_URL, eventUrl, REGISTRATION_FORM } from 'utils/constants';
import { validateLoginType } from 'utils/common';
import configureStore from '../../configureStore';
import * as types from '../../user/userTypes';

export default () => {
    const {
        store: { dispatch },
    } = configureStore;

    if (oktaAuth?.authStateManager?.getAuthState()?.isAuthenticated) {
        dispatch({
            type: types.UPDATE_LOGOUT_PERFORM_STATE,
            isLogoutAction: true,
        });
    }

    localStorage.setItem(localStorageKeys.ADMIN_VIEW_ACCESSIBLE, false);
    localStorage.removeItem(localStorageKeys.IMPERSONATED_USER);

    const redirectUrl = localStorage.getItem(localStorageKeys.REDIRECT_URL);
    const shouldPreserveRedirect =
        validateLoginType(eventUrl) ||
        redirectUrl?.includes(REGISTRATION_FORM) ||
        redirectUrl?.includes(EVENT_URL);

    if (!shouldPreserveRedirect) {
        localStorage.setItem(localStorageKeys.REDIRECT_URL, '');
        localStorage.setItem(localStorageKeys.EVENT_SPECIFIC_URL, '');
    }

    dispatch({ type: RESET_EVENTS });

    dispatch({
        type: types.LOGOUT,
    });
};
